/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Rank_Forbids_ProxiesInputs */



/**
* | output |
* | --- |
* | "Proxies are not allowed in National or Continental championships" |
*
* @param {Err_Tournament_Rank_Forbids_ProxiesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_rank_forbids_proxies = /** @type {((inputs?: Err_Tournament_Rank_Forbids_ProxiesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Rank_Forbids_ProxiesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les proxies ne sont pas autorisés dans le championnat national ou continental")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los proxies no están permitidos en el Campeonato Nacional o Continental")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Proxies não são permitidos em torneios National Championship ou Continental Championship")
	if (locale === "it") return /** @type {LocalizedString} */ ("I proxy non sono consentiti nel Campionato Nazionale o Continentale")
	return /** @type {LocalizedString} */ ("Proxies are not allowed in National or Continental championships")
});